/**
 * About component
 *
 * Space for you to describe more about yourself.
 */

import React from "react";

/**
 * About background image
 *
 * Below is a sample image. Upload the image of your choice into the "images"
 * directory and import here for use. Then, set imageAltText to string that
 * represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a image you
 * freely use on your site.
 */
import image from "../images/abouta.jpg";

const imageAltText = "blueish image for about";

/**
 * Sort description that expands on your title on the Home component.
 */
const description =
  "I'm an IoT Solutions Engineer @Liquid Intelligent Technologies, with background in Electrical and Electronic Engineering. Well experienced in IoT products development. I have previously worked as an R&D design Test engineer and Circuit/PCB designer. I’m passionate in transforming ideas to prototypes then to products. I’m highly passionate in making the technology accessible to everyone.";

/**
 * List of some of skills or technologies you work on, are learning,
 * passionate about, or enjoy,
 */
const skillsList = [
  "IoT Solutions",
  "Azure IoT Suite",
  "JSON data manipulations",
  "Python Programming",
  "PCB/Circuit design",
  "Embedded Systems",
  "R&D",
  "Solution/Tech Lead",
  "Azure AI/EmbeddedAI",
  "Working with Teams",
  "Firmware Innovator",
  "Customer Support",
  "ARM, ATMEL/AVR Microcontrollers - STM,Arduino, Raspberry Pi, Embedded AI Microcontrolers",
];

/**
 * Use this to give more information about what you are passionate about,
 * how you best work, or even a quote. This will help someone learn more
 * about you on a professional level.
 */
const detailOrQuote =
  "I am passionate about solving problems in new creative ways to drive innovation. By leveraging my IoT/Electronics/AI/Cloud experience I continually look for new and better ways to make tech accessible by all.";

const About = () => {
  return (
    <section className="padding" id="about">
      <img className="background" src={image} alt={imageAltText} />
      <div
        style={{
          backgroundColor: "white",
          width: "50%",
          padding: "4rem",
          margin: "3rem auto",
          textAlign: "center",
        }}
      >
        <h2>About Myself</h2>
        <p className="large">{description}</p>
        <hr />
        <ul
          style={{
            textAlign: "left",
            columns: 2,
            fontSize: "1.25rem",
            margin: "2rem 3rem",
            gap: "3rem",
          }}
        >
          {skillsList.map((skill) => (
            <li key={skill}>{skill}</li>
          ))}
        </ul>
        <hr />
        <p style={{ padding: "1rem 3rem 0" }}>{detailOrQuote}</p>
      </div>
    </section>
  );
};

export default About;
